












































































import { Vue, Component } from 'vue-property-decorator';
import { SHOW_SNACKBAR } from '../../common/constants';
import { ADMIN_ROUTES, LOGIN_PAGE } from '../../common/routes.config';
import { BrandWrite } from '../../common/types';
import { eventBus } from '../../main';
import adminModule from '../../store/modules/admin.module';
import brandModule from '../../store/modules/brand.module';
import errorModule from '../../store/modules/error.module';

@Component({
  components: {},
})
export default class AdminAddSubbrand extends Vue {
  showNewBrandDialog = false;

  brand: BrandWrite = {
    name: '',
    website: '',
    primary_color: '',
    secondary_color: '',
    description: '',
    parent_brand_id: '',
  };

  logoFile: File | null = null;

  subbrandDescription =
    "Sub-Brands are brands that have a different assets, products, and branding than its parent. You can manage all your brands from the parent brand's account. If you invite an admin to a sub-brand, they will only have access to that brand and not the parent. To give someone access to all of the sub-brands, add an admin to the parent brand.";

  get primaryColor(): string {
    // If brand is not set, make the primaryColor the chrncl brand color.
    return '#293645';
  }

  get secondaryColor(): string {
    return '#000000';
  }

  get brandFontColor(): string {
    return '#FFFFFF';
  }

  async createNewSubBrand() {
    if (!brandModule.brand) {
      return;
    }
    if (!this.logoFile) {
      eventBus.$emit(
        SHOW_SNACKBAR,
        'You must upload a logo for the brand to complete registration. This can be changed later.',
      );
      return;
    }
    this.showNewBrandDialog = false;
    this.brand.logo = this.logoFile.name;
    // Add parent brand's ID to the brand.
    const parentBrandId = brandModule.brand.id;
    this.brand.parent_brand_id = parentBrandId;

    const payload = { brand: this.brand, logo: this.logoFile };
    await brandModule.createSubBrand(payload);
    if (errorModule.hasError) {
      errorModule.clearError();
      return;
    }
    eventBus.$emit(
      SHOW_SNACKBAR,
      `Successfully added the brand ${this.brand.name} to your sub-brands. To access, go to the "Switch Brand" drop down at the top.`,
    );
  }
}
